export default __webpack_public_path__ + "static/media/refrigerator.3d7e1c93.svg";